module.exports = __webpack_public_path__ + "media/images/official/about_yamori_mochimune-0fef0817a1081ebf90c1120f597c5219.png";